import React from 'react';
import PropTypes from 'prop-types';
import { PrintIcon, EmailIcon, FacebookIcon, TwitterIcon, PinterestIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './allhomes-share-buttons.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Icons = {
  print: PrintIcon,
  email: EmailIcon,
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  pinterest: PinterestIcon
};
var titleMap = {
  facebook: 'Share on Facebook',
  twitter: 'Share on Twitter',
  pinterest: 'Share on Pinterest',
  print: 'Print',
  email: 'Email a friend'
};
var AllhomesShareButton = _ref => {
  var type = _ref.type,
    href = _ref.href,
    title = _ref.title,
    media = _ref.media,
    position = _ref.position;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var getIcon = () => {
    var Icon = Icons[type];
    return Icon ? ___EmotionJSX(Icon, {
      size: "regular"
    }) : ___EmotionJSX("div", null);
  };
  var getPopupUrl = () => {
    var popupUrlTemplate;
    switch (type) {
      case 'facebook':
        popupUrlTemplate = 'https://www.facebook.com/sharer.php?u={url}&t={title}';
        break;
      case 'twitter':
        popupUrlTemplate = 'https://twitter.com/intent/tweet?text={text}&url={url}';
        break;
      case 'pinterest':
        popupUrlTemplate = 'https://pinterest.com/pin/create/button/?description={title}&url={url}&media={media}';
        break;
      default:
        return null;
    }
    popupUrlTemplate = popupUrlTemplate.replace('{url}', encodeURIComponent(window.location.href));
    popupUrlTemplate = popupUrlTemplate.replace('{text}', encodeURIComponent(title));
    popupUrlTemplate = popupUrlTemplate.replace('{title}', encodeURIComponent(window.document.title));
    popupUrlTemplate = popupUrlTemplate.replace('{media}', encodeURIComponent(media));
    return popupUrlTemplate;
  };
  return ___EmotionJSX("button", {
    type: "button",
    css: styles.shareButton,
    title: titleMap[type],
    onClick: () => {
      sendEvent("".concat(type, "-click"), {
        position
      });
      var newWindow;
      switch (type) {
        case 'print':
        case 'email':
          window.location = href;
          break;
        case 'facebook':
          newWindow = window.open(getPopupUrl(), 'sharer', 'toolbar=0,status=0,width=626,height=436');
          break;
        case 'twitter':
          newWindow = window.open(getPopupUrl(), '', 'toolbar=0,status=0,width=626,height=436');
          break;
        case 'pinterest':
          newWindow = window.open(getPopupUrl(), '', 'toolbar=0,status=0,width=1050,height=823');
          break;
        default:
          return null;
      }
      if (newWindow) {
        newWindow.opener = null;
      }
      return false;
    }
  }, getIcon());
};
AllhomesShareButton.propTypes = {
  type: PropTypes.oneOf(['print', 'email', 'facebook', 'twitter', 'pinterest']).isRequired,
  href: PropTypes.string,
  title: PropTypes.string,
  media: PropTypes.string,
  position: PropTypes.number
};
AllhomesShareButton.defaultProps = {
  href: null,
  title: '',
  media: null,
  position: 0
};
export default AllhomesShareButton;